// =============================================================================
// constants/kpiConstants.js
// Action types e constantes do modulo KPI
// =============================================================================

// --- Incidents ---
export const INCIDENTS_FETCH_REQUEST = 'INCIDENTS_FETCH_REQUEST';
export const INCIDENTS_FETCH_SUCCESS = 'INCIDENTS_FETCH_SUCCESS';
export const INCIDENTS_FETCH_FAILURE = 'INCIDENTS_FETCH_FAILURE';

export const INCIDENT_HISTORY_FETCH_REQUEST = 'INCIDENT_HISTORY_FETCH_REQUEST';
export const INCIDENT_HISTORY_FETCH_SUCCESS = 'INCIDENT_HISTORY_FETCH_SUCCESS';
export const INCIDENT_HISTORY_FETCH_FAILURE = 'INCIDENT_HISTORY_FETCH_FAILURE';

export const INCIDENT_SELECT        = 'INCIDENT_SELECT';
export const INCIDENT_FILTER_CHANGE = 'INCIDENT_FILTER_CHANGE';
export const INCIDENT_FILTER_RESET  = 'INCIDENT_FILTER_RESET';

// --- Lookups (vendors, techs, kpis, severities, statuses da BD) ---
export const LOOKUPS_FETCH_REQUEST = 'LOOKUPS_FETCH_REQUEST';
export const LOOKUPS_FETCH_SUCCESS = 'LOOKUPS_FETCH_SUCCESS';
export const LOOKUPS_FETCH_FAILURE = 'LOOKUPS_FETCH_FAILURE';

// --- KPI Rules ---
export const RULES_FETCH_REQUEST = 'RULES_FETCH_REQUEST';
export const RULES_FETCH_SUCCESS = 'RULES_FETCH_SUCCESS';
export const RULES_FETCH_FAILURE = 'RULES_FETCH_FAILURE';

export const RULE_SAVE_REQUEST = 'RULE_SAVE_REQUEST';
export const RULE_SAVE_SUCCESS = 'RULE_SAVE_SUCCESS';
export const RULE_SAVE_FAILURE = 'RULE_SAVE_FAILURE';

export const RULE_DELETE_REQUEST = 'RULE_DELETE_REQUEST';
export const RULE_DELETE_SUCCESS = 'RULE_DELETE_SUCCESS';
export const RULE_DELETE_FAILURE = 'RULE_DELETE_FAILURE';

export const RULE_SELECT     = 'RULE_SELECT';
export const RULE_FORM_RESET = 'RULE_FORM_RESET';

export const FORMULA_VALIDATE_REQUEST = 'FORMULA_VALIDATE_REQUEST';
export const FORMULA_VALIDATE_SUCCESS = 'FORMULA_VALIDATE_SUCCESS';
export const FORMULA_VALIDATE_FAILURE = 'FORMULA_VALIDATE_FAILURE';
export const FORMULA_VALIDATE_RESET   = 'FORMULA_VALIDATE_RESET';

// --- Engine Logs ---
export const ENGINE_LOGS_FETCH_REQUEST = 'ENGINE_LOGS_FETCH_REQUEST';
export const ENGINE_LOGS_FETCH_SUCCESS = 'ENGINE_LOGS_FETCH_SUCCESS';
export const ENGINE_LOGS_FETCH_FAILURE = 'ENGINE_LOGS_FETCH_FAILURE';

// =============================================================================
// Opcoes de UI
// =============================================================================

export const TECH_OPTIONS = ['2G', '3G', '4G', '5G'];

export const STATUS_OPTIONS = [
	{ value: 'Open',   label: 'Aberto'  },
	{ value: 'Closed', label: 'Fechado' },
];

export const DIRECTION_OPTIONS = [
	{ value: false, label: 'Cair e mau (Availability, Setup SR, Throughput)' },
	{ value: true,  label: 'Subir e mau (Drop Rate, Block Rate, PRB Utilization)' },
];

export const DETECTION_METHOD_OPTIONS = [
	{
		value: 'PERCENTILE',
		label: 'Percentil (recomendado)',
		description:
			'Compara o KPI atual contra a distribuicao historica desta celula (P95/P5). '
			+ 'Robusto a distribuicoes nao-normais (Drop Rate, Block Rate). '
			+ 'O alarme so dispara quando o KPI passa SIMULTANEAMENTE o SLA absoluto E o seu proprio percentil.',
	},
	{
		value: 'THRESHOLD',
		label: 'Threshold (SLA fixo)',
		description:
			'Dispara apenas quando o KPI passa o limiar SLA absoluto. Sem comparacao com historico. '
			+ 'Usar quando ha SLA contratual rigido (ex: Availability < 98.5%).',
	},
	{
		value: 'ZSCORE',
		label: 'Z-Score (estatistico classico)',
		description:
			'Compara o KPI contra media+/-2.5 desvios-padrao historicos. '
			+ 'Recomendado para Availability (distribuicao perto de 100% com Stdev pequeno). '
			+ 'Menos robusto que Percentil para Drop Rates.',
	},
];

export const SEVERITY_OPTIONS = [
	{ value: 1, label: 'Critical', color: '#d32f2f' },
	{ value: 2, label: 'High',     color: '#ed6c02' },
	{ value: 3, label: 'Medium',   color: '#0288d1' },
];

export const DURATION_OPTIONS = [
	{ value: 'all',  label: 'Qualquer duracao' },
	{ value: 'lt1',  label: '< 1 dia (hoje)' },
	{ value: '1to3', label: '1 a 3 dias' },
	{ value: '4to7', label: '4 a 7 dias' },
	{ value: 'gt7',  label: '> 7 dias (cronicos)' },
];

export const TECH_COLOR = {
	'2G': '#f59e0b',
	'3G': '#3b82f6',
	'4G': '#10b981',
	'5G': '#8b5cf6',
};

// =============================================================================
// Tooltips longos (mostrados nos campos do formulario)
// =============================================================================

export const TOOLTIPS = {
	detectionMethod:
		'Metodo estatistico a aplicar.\n\n'
		+ 'PERCENTILE: compara KPI contra os percentis historicos desta celula (P95/P5).\n'
		+ 'THRESHOLD: usa apenas o SLA absoluto.\n'
		+ 'ZSCORE: compara contra media e desvio-padrao.\n\n'
		+ 'Recomendado para Drop Rates: PERCENTILE.\n'
		+ 'Recomendado para Availability: ZSCORE.',

	slaThreshold:
		'Limiar absoluto baseado em SLA contratual.\n\n'
		+ 'Direction "subir e mau": KPI > SLA dispara o criterio absoluto.\n'
		+ 'Direction "cair e mau": KPI < SLA dispara o criterio absoluto.\n\n'
		+ 'Em PERCENTILE: tem que ser combinado com o percentil (AND).\n'
		+ 'Em THRESHOLD: condicao unica.\n\n'
		+ 'Exemplos:\n'
		+ '- Voice Drop Rate 4G: 0.8 (= 0.8%)\n'
		+ '- Voice Setup SR 4G: 99.0\n'
		+ '- Availability: 98.5',

	direction:
		'Sentido em que a degradacao do KPI ocorre.\n\n'
		+ 'Subir e mau: para KPIs onde subida indica problema (Drop Rate, Block Rate, PRB Utilization).\n\n'
		+ 'Cair e mau: para KPIs onde queda indica problema (Availability, Setup SR, Throughput, CQI).',

	minVolumeAbsolute:
		'CHAO MINIMO ESTATISTICO (nao confundir com volume de producao).\n\n'
		+ 'O filtro efetivo aplicado pelo motor e:\n'
		+ 'MAX(este valor, Volume_Medio_Historico × 0.30)\n\n'
		+ 'Ou seja:\n'
		+ '- Celula urbana com volume medio 5000: filtro = max(20, 1500) = 1500\n'
		+ '- Celula rural com volume medio 80: filtro = max(20, 24) = 24\n'
		+ '- Celula rural mesmo pequena (medio 30): filtro = max(20, 9) = 20\n\n'
		+ 'Valores tipicos: 2G=15, 3G=20, 4G=20, 5G=15.',

	useDayOfWeek:
		'Filtrar a baseline pelo dia-da-semana?\n\n'
		+ 'SIM (recomendado para Drop Rates, Throughput, Setup SR):\n'
		+ 'A baseline e calculada com as 12 ocorrencias mais recentes do mesmo dia-da-semana. '
		+ 'Isto isola padroes semanais (sexta a noite vs domingo).\n\n'
		+ 'NAO (recomendado para Availability):\n'
		+ 'A baseline e calculada com os ultimos 28 dias consecutivos. '
		+ 'Apropriado para KPIs cuja variabilidade NAO depende do dia-da-semana '
		+ '(avarias, alarmes de equipamento).',

	severity:
		'Severidade operacional do alarme.\n\n'
		+ 'Critical (1): impacto directo no servico — Availability, Drop Rates.\n'
		+ 'High (2): impacto na experiencia — Setup SR, Block Rates.\n'
		+ 'Medium (3): indicadores de qualidade — Throughput, CQI.',
};

// =============================================================================
// Perfis pre-configurados — usados pelo botao "Sugerir Valores Tipicos"
// =============================================================================

export const KPI_PROFILES = [
	{
		key: 'drop_rate_2g',
		label: 'Drop Rate (2G)',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      2.0,
			direction:         true,
			minVolumeAbsolute: 15,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_3g',
		label: 'Drop Rate (3G)',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      1.0,
			direction:         true,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_4g',
		label: 'Drop Rate (4G)',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      0.8,
			direction:         true,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'drop_rate_5g',
		label: 'Drop Rate (5G)',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      1.2,
			direction:         true,
			minVolumeAbsolute: 15,
			useDayOfWeek:      true,
			severity:          1,
		},
	},
	{
		key: 'setup_sr_voice',
		label: 'Voice Setup SR',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      99.0,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          2,
		},
	},
	{
		key: 'setup_sr_data',
		label: 'Data Setup SR',
		preset: {
			detectionMethod:   'PERCENTILE',
			slaThreshold:      97.0,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      true,
			severity:          2,
		},
	},
	{
		key: 'availability',
		label: 'Availability',
		preset: {
			detectionMethod:   'ZSCORE',
			slaThreshold:      98.5,
			direction:         false,
			minVolumeAbsolute: 20,
			useDayOfWeek:      false,
			severity:          1,
		},
	},
];

// ============================================================================
// Valores iniciais para nova regra
// ============================================================================

export const EMPTY_RULE = {
	kpiId:             0,
	kpiName:           '',
	tech:              '4G',
	sourceTable:       '',
	sourceVendorCol:   'VENDOR',
	sourceSiteCol:     'JV_ID',
	sourceCellCol:     'MI_MYCOM_ID',
	sourceDateCol:     'DATE',
	kpiFormula:        '',
	volFormula:        '',
	detectionMethod:   'PERCENTILE',
	slaThreshold:      0,
	direction:         true,
	minVolumeAbsolute: 20,
	useDayOfWeek:      true,
	severity:          2,
	active:            true,
};